var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#896978"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.672 13.172C13.5 14.343 13.5 16.229 13.5 20V24C13.5 27.771 13.5 29.657 14.672 30.828C15.843 32 17.729 32 21.5 32H23.5C27.271 32 29.157 32 30.328 30.828C31.5 29.657 31.5 27.771 31.5 24V20C31.5 16.229 31.5 14.343 30.328 13.172C29.157 12 27.271 12 23.5 12H21.5C17.729 12 15.843 12 14.672 13.172ZM17.75 18C17.75 17.8011 17.829 17.6103 17.9697 17.4697C18.1103 17.329 18.3011 17.25 18.5 17.25H26.5C26.6989 17.25 26.8897 17.329 27.0303 17.4697C27.171 17.6103 27.25 17.8011 27.25 18C27.25 18.1989 27.171 18.3897 27.0303 18.5303C26.8897 18.671 26.6989 18.75 26.5 18.75H18.5C18.3011 18.75 18.1103 18.671 17.9697 18.5303C17.829 18.3897 17.75 18.1989 17.75 18ZM17.75 22C17.75 21.8011 17.829 21.6103 17.9697 21.4697C18.1103 21.329 18.3011 21.25 18.5 21.25H26.5C26.6989 21.25 26.8897 21.329 27.0303 21.4697C27.171 21.6103 27.25 21.8011 27.25 22C27.25 22.1989 27.171 22.3897 27.0303 22.5303C26.8897 22.671 26.6989 22.75 26.5 22.75H18.5C18.3011 22.75 18.1103 22.671 17.9697 22.5303C17.829 22.3897 17.75 22.1989 17.75 22ZM18.5 25.25C18.3011 25.25 18.1103 25.329 17.9697 25.4697C17.829 25.6103 17.75 25.8011 17.75 26C17.75 26.1989 17.829 26.3897 17.9697 26.5303C18.1103 26.671 18.3011 26.75 18.5 26.75H23.5C23.6989 26.75 23.8897 26.671 24.0303 26.5303C24.171 26.3897 24.25 26.1989 24.25 26C24.25 25.8011 24.171 25.6103 24.0303 25.4697C23.8897 25.329 23.6989 25.25 23.5 25.25H18.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlans);
export default __webpack_public_path__ + "static/media/plans.d411d7bb8798d70d51c81c5528321f9b.svg";
export { ForwardRef as ReactComponent };